import { UserModel } from './user.model';

export class ActionModel
{
	id: number = undefined;
	name:string = undefined;
	start: any = undefined; //{ date:''};
	end: any = undefined; //{ date:''};
	budget: number = undefined;
	status: number = undefined;	/*0:TODO,1:Work In Progress, 2:finished,-1:new, -2:canceled*/
	place: number = undefined;
  details: string = undefined;

  jsonDetails:any = {};

  origUsers:Array<UserModel> = [];
  currentUsers:Array<UserModel> = [];

  creationMode:boolean = false;
  saveIt:boolean = false;


	constructor(values, creation=false) {
    if(creation) {
      this.creationMode = true;
      this.status = -1;
    }
		else this.exchange(values, false);
	}
	
	exchange(values: Object = {}, isObject=false) {
	    for (let p in values) {
	    	
		    if (this.hasOwnProperty(p) && values.hasOwnProperty(p)) {
		    	if(p == 'id' && this.id != undefined) {
		    		continue;
		    	}
          else if(p=='start' || p=='end') {
            if(values[p]!=null) this[p] = values[p].date.split(' ')[0];
          }
          else if(p=='users') {
          }
		    	else {
		    		if(isObject) this[p].exchange(values[p]);
		    		else this[p] = values[p];
		    	}
		    }
		}

    this.jsonDetails = this.details ? JSON.parse(this.details) : {};
	}

  getStringStatus(status:number=null)
  {
    if(status==null) status = this.status;
    
  	switch (status) {
      case -1:
        return 'NOUVELLE ACTION';
        break;
  		case 0:
  			return 'NON TRAITÉ';
  			break;
  		case 1:
  			return 'EN COURS';
  			break;
  		case 2:
  			return 'TERMINÉ';
  			break;
  		
  		default:
  			// code...
  			break;
  	}
  }


  get actionName()
  {
    return this.name;
  }
  set actionName(a:string)
  {
    this.name = a;
    this.saveIt = true;
  }

  get startDate()
  {
    return this.start;
  }
  set startDate(d:string)
  {
    this.start = d;
    this.saveIt = true;
  }

  get endDate()
  {
    //if(!this.end) return '';
    return this.end;//.date;
  }
  set endDate(d:string)
  {
    this.end = d;//{date: d};
    this.saveIt = true;
  }

  get actionStatus()
  {
    return this.status;
  }
  set actionStatus(s:number)
  {
    this.status = s;
    this.saveIt = true;
  }

  get actionPlace()
  {
    return this.place;
  }
  set actionPlace(o:number)
  {
    this.place = o;
    this.saveIt = true;
  }

  get actionBudget()
  {
    return this.budget;
  }
  set actionBudget(b:number)
  {
    this.budget = b;
    this.saveIt = true;
  }


  get description()
  {
    return this.jsonDetails.description && typeof this.jsonDetails.description=='string'
      ? this.jsonDetails.description : "";
  }
  set description(d:string)
  {
    this.jsonDetails.description = d;
    this.saveIt = true;
  }

  get todo()
  {
    return this.jsonDetails.todo ? this.jsonDetails.todo : null;
  }
  set todo(t:Array<any>)
  {
    this.jsonDetails.todo = t;
    this.saveIt = true;
  }
  get todoRatio()
  {
    if(this.jsonDetails.todo==undefined) return null;
    let total = this.jsonDetails.todo.length;
    if(total==0) return null;
    let checked = this.jsonDetails.todo.filter((task)=>{return task.done}).length;
    let ratio = 100*checked / total;
    return Math.round(ratio);
  }
  get todoFraction()
  {
    if(this.jsonDetails.todo==undefined) return '';
    let total = this.jsonDetails.todo.length;
    let checked = this.jsonDetails.todo.filter((task)=>{return task.done}).length;
    return checked+'/'+total;
  }

  get comments()
  {
    return this.jsonDetails.comments ? this.jsonDetails.comments : null;
  }
  set comments(c:Array<any>)
  {
    this.jsonDetails.comments = c;
    this.saveIt = true;
  }
  get commentsCount()
  {
    return (this.jsonDetails!=undefined && this.jsonDetails.comments!=undefined) 
            ? this.jsonDetails.comments.length : 0;
  }

  get users()
  {
    return this.currentUsers;
  }
  set users(u:Array<UserModel>)
  {
    this.currentUsers = u;
    this.saveIt = true;
  }
  get user_add()
  {
    let add = [];
    this.currentUsers.forEach((user:UserModel)=>{
      if(!this.origUsers.includes(user))
        add.push(user.id);
    });
    return add;
  }
  get user_remove()
  {
    let remove = [];
    this.origUsers.forEach((user:UserModel)=>{
      if(!this.currentUsers.includes(user))
        remove.push(user.id);
    });
    return remove;
  }

  export()
  {
    return {
      id: this.id,
      name: this.actionName,
      start: this.startDate,
      end: this.endDate,
      budget: this.budget,
      status: this.status,
      place: this.place,
      details: JSON.stringify(this.jsonDetails),
      user_add: this.user_add,
      user_remove: this.user_remove
    }
  }
}